"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const collection = (sdk) => {
    const { sdkConfig: { url }, defaultVersion, } = sdk;
    const httpClient = sdk.httpClient;
    return {
        addItemToCollection: async (collectionId, itemType, itemId) => {
            const endpoint = `${url}/${defaultVersion}/collections/${collectionId}/${itemType}s`;
            const payload = {};
            if (itemType === 'mindItem') {
                payload.mindItem = itemId;
            }
            else {
                payload.productId = itemId;
            }
            const result = await httpClient.put(endpoint, { payload });
            return result.data;
        },
        createCollection: async (payload) => {
            const endpoint = `${url}/${defaultVersion}/collections/`;
            const result = await httpClient.post(endpoint, { payload });
            return result.data;
        },
        deleteCollection: async (collectionId) => {
            const endpoint = `${url}/${defaultVersion}/collections/${collectionId}`;
            const result = await httpClient.delete(endpoint);
            return result.data;
        },
        deleteItemFromCollection: async (collectionId, itemType, itemId) => {
            const endpoint = `${url}/${defaultVersion}/collections/${collectionId}/${itemType}s/${itemId}`;
            const result = await httpClient.delete(endpoint);
            return result.data;
        },
        getCollectionById: async (collectionId) => {
            const endpoint = `${url}/${defaultVersion}/collections/${collectionId}`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getCollectionContentsByCollectionId: async (collectionId, pagination) => {
            const endpoint = `${url}/${defaultVersion}/collections/${collectionId}/contents`;
            const result = await httpClient.get(endpoint, { query: pagination });
            return result;
        },
        getCuratedCollections: async () => {
            const endpoint = `${url}/${defaultVersion}/collections/curated`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        updateCollection: async (collectionId, payload) => {
            const endpoint = `${url}/${defaultVersion}/collections/${collectionId}`;
            const result = await httpClient.put(endpoint, { payload });
            return result.data;
        },
        addFollower: async (collectionId, userId) => {
            const endpoint = `${url}/${defaultVersion}/collections/${collectionId}/followers/${userId}`;
            const result = await httpClient.put(endpoint);
            return result.data;
        },
        deleteFollower: async (collectionId, userId) => {
            const endpoint = `${url}/${defaultVersion}/collections/${collectionId}/followers/${userId}`;
            const result = await httpClient.delete(endpoint);
            return result.data;
        },
    };
};
exports.default = collection;
